/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import PaymentIcon from "@mui/icons-material/Payment";
import StarIcon from "@mui/icons-material/Star";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import VerifiedIcon from "@mui/icons-material/Verified";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Box,
  Tab,
  Tabs,
  TableCell,
  TableBody,
  TableRow,
  TableHead,
  Table,
  TableContainer,
  MenuItem,
  Select,
  IconButton,
  SelectChangeEvent,
  Button,
  Stack,
  Typography,
  Divider,
  TextField,
  Menu,
  MenuList,
  CardMedia,
  Input,
} from "@mui/material";

import CircleIcon from "@mui/icons-material/Circle";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import SearchBar from "../../components/SearchBar";
import InfoIcon from "@mui/icons-material/Info";
import RejectReasonModal from "../../Modals/rejectReason";
import SendPayout from "../../Modals/sendPayout";
import SwitchToggle from "../../components/SwitchToggle";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ViewHealthScores from "../../Modals/viewHealthScores";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ViewVendor = () => {
  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = useState(0);
  const [valueTabs1, setValueTabs1] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };
  const [city, setCity] = useState("default");
  const [open3, setOpen3] = useState(false);
  const [tradeLicenseImage, setTradeLicenseImage] = useState<string>("");
  const [moaImage, setMoaImage] = useState<string>("");
  const handleCloseModal3 = () => {
    setOpen3(false);
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedOrder, setSelectedOrder] = useState<any>(null);
  const openActionMenu = Boolean(anchorEl);

  const handleActionClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    order: any,
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedOrder(order);
  };

  const handleActionClose = () => {
    setAnchorEl(null);
    setSelectedOrder(null);
  };

  const earningsColumns = [
    { id: "orderId", label: "Order ID" },
    { id: "customer", label: "Customer Detail" },
    { id: "orderAmount", label: "Order Amount" },
    { id: "shippingCharge", label: "Shipping Charge" },
    { id: "commission", label: "Commission" },
    { id: "paymentMethod", label: "Payment Method" },
    { id: "orderDate", label: "Order Date" },
    { id: "status", label: "Status" },
  ];

  const earningsData = [
    {
      orderId: "#ORD001",
      customer: {
        name: "Rajesh Sharma",
        email: "rajesh@example.com",
      },
      orderAmount: 4000,
      shippingCharge: 100,
      commission: 400,
      paymentMethod: "Online",
      orderDate: "10 Oct 2025",
      status: "Paid",
    },
    {
      orderId: "#ORD002",
      customer: {
        name: "Priya Verma",
        email: "priya@example.com",
      },
      orderAmount: 2800,
      shippingCharge: 50,
      commission: 280,
      paymentMethod: "COD",
      orderDate: "12 Oct 2025",
      status: "Pending",
    },
    {
      orderId: "#ORD003",
      customer: {
        name: "Ankit Mehra",
        email: "ankit@example.com",
      },
      orderAmount: 3500,
      shippingCharge: 75,
      commission: 350,
      paymentMethod: "UPI",
      orderDate: "14 Oct 2025",
      status: "Paid",
    },
  ];
  const products = [
    {
      id: "#PROD-001",
      name: "Men Sports Shoes",
      category: "Footwear",
      brand: "Nike",
      stock: 120,
      status: true,
      createdDate: "30 July 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "Mike Johnson",
        email: "mike@example.com",
        phone: "+1122334455",
      },
    },
    {
      id: "#PROD-002",
      name: "Women Running Shoes",
      category: "Footwear",
      brand: "Adidas",
      stock: 45,
      status: true,
      createdDate: "18 July 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "John Doe",
        email: "john@example.com",
        phone: "+123456789",
      },
    },
    {
      id: "#PROD-003",
      name: "Casual Sneakers",
      category: "Footwear",
      brand: "Puma",
      stock: 8, // low stock
      status: false,
      createdDate: "05 July 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "Jane Smith",
        email: "jane@example.com",
        phone: "+987654321",
      },
    },
    {
      id: "#PROD-004",
      name: "Men Cotton T-Shirt",
      category: "Clothing",
      brand: "H&M",
      stock: 200,
      status: true,
      createdDate: "22 June 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "Sarah Lee",
        email: "sarah@example.com",
        phone: "+9988776655",
      },
    },
    {
      id: "#PROD-005",
      name: "Women Hoodie",
      category: "Clothing",
      brand: "Zara",
      stock: 12,
      status: false,
      createdDate: "12 June 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "John Doe",
        email: "john@example.com",
        phone: "+123456789",
      },
    },
    {
      id: "#PROD-006",
      name: "Leather Wallet",
      category: "Accessories",
      brand: "Fossil",
      stock: 90,
      status: true,
      createdDate: "02 June 2025",
      vendor: {
        name: "Jane Smith",
        email: "jane@example.com",
        phone: "+987654321",
      },

      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD-007",
      name: "Smart Watch Series 8",
      category: "Accessories",
      brand: "Apple",
      stock: 5, // very low stock
      status: true,
      createdDate: "28 May 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "Mike Johnson",
        email: "mike@example.com",
        phone: "+1122334455",
      },
    },
    {
      id: "#PROD-008",
      name: "Wireless Earbuds",
      category: "Accessories",
      brand: "Samsung",
      stock: 60,
      status: false,
      createdDate: "15 May 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "Sarah Lee",
        email: "sarah@example.com",
        phone: "+9988776655",
      },
    },
  ];

  const reviews = [
    {
      id: "REV001",
      name: "Nader Qasim",
      email: "nader.qasim@gmail.com",
      phone: "+971 50 123 4567",
      verified: true,
      date: "12/12/2025",
      orderId: "ORD-2025-1123",
      productId: "PRD-88921",
      productName: "Premium Leather Backpack",
      rating: 5,
      title: "Exceeded expectations",
      review:
        "Absolutely love this product! The quality is exceptional and delivery was super fast. Highly recommend to anyone looking for premium items.",
      status: "approved",
    },
    {
      id: "REV002",
      name: "Mohammed Khan",
      email: "mohammed.khan@example.com",
      phone: "+971 55 987 2341",
      verified: true,
      date: "12/12/2025",
      orderId: "ORD-2025-1140",
      productId: "PRD-77210",
      productName: "Wireless Noise Cancelling Headphones",
      rating: 4,
      title: "Very good quality",
      review:
        "Exceeded my expectations. The packaging was beautiful and the product itself is even better in person. Will definitely order again.",
      status: "approved",
    },
    {
      id: "REV003",
      name: "Sara Ahmed",
      email: "sara.ahmed@example.com",
      phone: "+971 52 456 8899",
      verified: false,
      date: "11/12/2025",
      orderId: "ORD-2025-1189",
      productId: "PRD-66543",
      productName: "Smart Fitness Watch",
      rating: 3,
      title: "Good but needs improvement",
      review:
        "The watch is good for basic tracking, but battery life could be better. UI feels a bit laggy sometimes.",
      status: "pending",
    },
    {
      id: "REV004",
      name: "Amit Verma",
      email: "amit.verma@example.com",
      phone: "+91 98765 43210",
      verified: true,
      date: "10/12/2025",
      orderId: "ORD-2025-1199",
      productId: "PRD-55221",
      productName: "Ergonomic Office Chair",
      rating: 2,
      title: "Not satisfied",
      review:
        "The chair looks good but comfort is not as expected. Back support is weak and assembly instructions were unclear.",
      status: "approved",
    },
  ];

  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const tabLabels = [
    "All",
    "Pending",
    "Accepted",
    "Ongoing",
    "Completed",
    "Cancelled",
  ];
  const subscriptionHistory = [
    {
      id: 1,
      name: "Basic Plan",
      features: ["Up to 50 Orders", "Standard Support"],
      validity: "1 Month",
      price: "AED 199",
      startDate: "01 Jan 2025",
      endDate: "31 Jan 2025",
    },
    {
      id: 2,
      name: "Pro Plan",
      features: ["Unlimited Orders", "Priority Support", "Analytics"],
      validity: "3 Months",
      price: "AED 499",
      startDate: "01 Feb 2025",
      endDate: "30 Apr 2025",
    },
    {
      id: 3,
      name: "Enterprise Plan",
      features: ["Unlimited Orders", "Dedicated Manager", "Advanced Reports"],
      validity: "6 Months",
      price: "AED 899",
      startDate: "01 May 2025",
      endDate: "31 Oct 2025",
    },
  ];
  const transactionHistory = [
    {
      date: "2025-01-25",
      transactionId: "SUB3001",
      transactionType: "Premium Tools Subscription",
      amount: "AED 999",
    },
    {
      date: "2025-01-20",
      transactionId: "SUB3002",
      transactionType: "Add Product for Recommendation",
      amount: "AED 1499",
    },
    {
      date: "2025-01-15",
      transactionId: "SUB2998",
      transactionType: "Purchased Queries",
      amount: "AED 499",
    },
    {
      date: "2025-01-10",
      transactionId: "SUB2995",
      transactionType: "Premium Tools Renewal",
      amount: "AED 999",
    },
    {
      date: "2025-01-05",
      transactionId: "SUB2990",
      transactionType: "Homepage Featured Listing",
      amount: "AED 1999",
    },
    {
      date: "2024-12-28",
      transactionId: "SUB2982",
      transactionType: "Extra Product Upload Slots (50 Products)",
      amount: "AED 799",
    },
    {
      date: "2024-12-20",
      transactionId: "SUB2975",
      transactionType: "Advanced Analytics Access",
      amount: "AED 1299",
    },
    {
      date: "2024-12-15",
      transactionId: "SUB2970",
      transactionType: "Vendor Verification Badge",
      amount: "AED 299",
    },
    {
      date: "2024-12-10",
      transactionId: "SUB2964",
      transactionType: "Premium Support (Monthly)",
      amount: "AED 599",
    },
    {
      date: "2024-12-05",
      transactionId: "SUB2959",
      transactionType: "Seasonal Promotion Package",
      amount: "AED 2499",
    },
    {
      date: "2024-11-28",
      transactionId: "SUB2952",
      transactionType: "Premium Tools Subscription",
      amount: "AED 999",
    },
    {
      date: "2024-11-20",
      transactionId: "SUB2944",
      transactionType: "Product SEO Optimization Add-on",
      amount: "AED 899",
    },
  ];
  const referralHistory = [
    {
      name: "John Doe",
      email: "john@example.com",
      phone: "9876543210",
      status: "In Process",
    },
    {
      name: "Sarah Smith",
      email: "sarah@example.com",
      phone: "9123456780",
      status: "Completed",
    },
    {
      name: "Amit Verma",
      email: "amit.verma@gmail.com",
      phone: "9988776655",
      status: "Completed",
    },
    {
      name: "Neha Sharma",
      email: "neha.sharma@gmail.com",
      phone: "9090909090",
      status: "In Process",
    },
    {
      name: "Rahul Mehta",
      email: "rahul.mehta@gmail.com",
      phone: "9012345678",
      status: "Completed",
    },
  ];

  const ongoingOrders = [
    {
      id: 1,
      thumbnail: "/static/images/placeholder.png",
      serviceName: "Product Description Bundle (20 Items)",
      description:
        "High-quality English & Arabic product descriptions crafted to boost conversions and improve SEO ranking.",
      providerName: "Creative Content Ltd.",
      date: "2025-12-05",
      time: "14:00",
      deliveryDays: 2,
      price: 250,
      status: "Pending",
      paymentStatus: "Paid",
    },
    {
      id: 2,
      thumbnail: "/static/images/placeholder.png",
      serviceName: "Monthly Blog Writing (12 Blogs)",
      description:
        "Professionally researched and SEO-optimized blogs to increase organic traffic and strengthen brand authority.",
      providerName: "BlogMasters",
      date: "2025-12-10",
      time: "10:00",
      deliveryDays: 7,
      price: 850,
      status: "Accepted",
      paymentStatus: "Paid",
    },
    {
      id: 3,
      thumbnail: "/static/images/placeholder.png",
      serviceName: "Social Media Captions Package (40 Captions)",
      description:
        "Creative, engaging captions for Facebook, Instagram & TikTok written to increase engagement and impressions.",
      providerName: "SocialGurus",
      date: "2025-12-07",
      time: "09:30",
      deliveryDays: 3,
      price: 180,
      status: "In Progress",
      paymentStatus: "Pending",
    },
  ];
  const data = [
    {
      id: 1,
      licenseName: "Trade License - TL-27834",
      uploadedDate: "2024-10-05",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2025-12-30",
    },
    {
      id: 2,
      licenseName: "MOA - MOA-98345",
      uploadedDate: "2024-08-11",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2025-08-15",
    },
    {
      id: 3,
      licenseName: "MOA  - MOA-55219",
      uploadedDate: "2024-09-21",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2026-01-10",
    },
    {
      id: 4,
      licenseName: "Trade License - TL-66102",
      uploadedDate: "2024-07-30",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2025-11-05",
    },
    {
      id: 5,
      licenseName: "MOA  - MOA-11987",
      uploadedDate: "2024-11-13",
      docUrl: "/static/images/placeholder.png",
      expiryDate: "2026-03-18",
    },
  ];
  const orderData = [
    {
      orderId: "ORD-2025-001",
      store: "TechHub Electronics",
      vendor: {
        name: "TechHub Electronics",
        email: "support@techhub.com",
      },
      customer: {
        name: "Mohammed Al Mansoori",
        email: "mohammed@example.com",
      },
      date: "12/12/2025",
      time: "4:47:53 PM",
      total: "AED 447.50",
      payment: "Paid",
      paymentMethod: "Card",
      status: "Delivered",
    },
    {
      orderId: "ORD-2025-002",
      store: "TechHub Electronics",
      vendor: {
        name: "TechHub Electronics",
        email: "sales@techhub.com",
      },
      customer: {
        name: "Sara Ahmed",
        email: "sara@example.com",
      },
      date: "12/12/2025",
      time: "4:47:53 PM",
      total: "AED 287.50",
      payment: "Paid",
      paymentMethod: "Cash",
      status: "Shipped",
    },
  ];
  const purchasedQueries = [
    {
      queries: 1000,
      amount: "AED 199",
      date: "2025-01-05",
    },
    {
      queries: 2500,
      amount: "AED 399",
      date: "2025-01-12",
    },
    {
      queries: 5000,
      amount: "AED 699",
      date: "2025-01-20",
    },
    {
      queries: 10000,
      amount: "AED 1,199",
      date: "2025-02-02",
    },
    {
      queries: 20000,
      amount: "AED 1,999",
      date: "2025-02-10",
    },
  ];
  const boutiquePoints = [
    {
      type: "Referral",
      referenceId: "REF_1023",
      points: 50,
    },
    {
      type: "Service Booking",
      referenceId: "SB_4589",
      points: 120,
    },
    {
      type: "Order",
      referenceId: "ORD_7821",
      points: 80,
    },
    {
      type: "Referral",
      referenceId: "REF_1045",
      points: 50,
    },
    {
      type: "Order",
      referenceId: "ORD_7934",
      points: 100,
    },
  ];
  const campaigns = [
    {
      campaignName: "Diwali Mega Sale",
      campaignType: "Discount",
      discountType: "Percentage",
      discountValue: 15,
      startDate: "20 Nov 2025",
      endDate: "30 Nov 2025",
      minPurchase: 500,
      usageLimit: 100,
      createdDate: "10 Nov 2025",
    },
    {
      campaignName: "Free Shipping Weekend",
      campaignType: "Free Shipping",
      discountType: null,
      discountValue: null,
      startDate: "15 Dec 2025",
      endDate: "17 Dec 2025",
      minPurchase: null,
      usageLimit: "Unlimited",
      createdDate: "05 Dec 2025",
    },
  ];

  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };

  const payoutData = [
    {
      vendorId: "VND-001",
      period: "Jan 2025",
      subscriptionType: "Premium",
      orders: 18,
      grossAmount: "AED 3,200",
      commissionRate: "10%",
      commission: "AED 320",
      netAmount: "AED 2,880",
      status: "Completed",
      statusClass: "success",
    },
    {
      vendorId: "VND-002",
      period: "Jan 2025",
      subscriptionType: "Standard",
      orders: 9,
      grossAmount: "AED 1,450",
      commissionRate: "10%",
      commission: "AED 145",
      netAmount: "AED 1,305",
      status: "Pending",
      statusClass: "warning",
    },
  ];

  const scheduledPayouts = [
    {
      id: "SCH-001",
      vendor: "ABC Electronics",
      subscriptionType: "Premium",
      plan: "Weekly Payout",
      commissionRate: 8,
      amount: "AED 400",
      expiry: "2025-12-31",
      status: "Pending",
    },
    {
      id: "SCH-002",
      vendor: "Fashion Hub",
      subscriptionType: "Standard",
      plan: "Monthly Payout",
      commissionRate: 10,
      amount: "AED 400",
      expiry: "2025-06-30",
      status: "Pending",
    },
  ];

  const vendorBalances = [
    {
      id: "BAL-001",
      vendorId: "VND-1001",
      vendorName: "ABC Electronics",
      subscriptionType: "Premium",
      commissionRate: "8%",
      pendingAmount: "AED 4,250.00",
      lastPayout: "AED 12,800.00",
      lastPayoutDate: "15 Mar 2025",
      status: "Pending",
      statusClass: "warning",
    },
    {
      id: "BAL-002",
      vendorId: "VND-1002",
      vendorName: "Fashion Hub",
      subscriptionType: "Standard",
      commissionRate: "10%",
      pendingAmount: "AED 0.00",
      lastPayout: "AED 9,500.00",
      lastPayoutDate: "10 Mar 2025",
      status: "Settled",
      statusClass: "success",
    },
  ];

  const transactionLogs = [
    {
      id: "TXN-1001",
      type: "Payout",
      amount: "AED 2,880.00",
      gateway: "Stripe",
      reference: "STRP-849302",
      date: "15 Mar 2025",
      status: "Completed",
      statusClass: "success",
    },
    {
      id: "TXN-1002",
      type: "Refund",
      amount: "AED 450.00",
      gateway: "PayPal",
      reference: "PP-REF-22991",
      date: "18 Mar 2025",
      status: "Pending",
      statusClass: "warning",
    },
    {
      id: "TXN-1003",
      type: "Payout",
      amount: "AED 1,305.00",
      gateway: "Stripe",
      reference: "STRP-774120",
      date: "20 Mar 2025",
      status: "Failed",
      statusClass: "danger",
    },
    {
      id: "TXN-1004",
      type: "Commission",
      amount: "AED 320.00",
      gateway: "Wallet",
      reference: "WLT-003212",
      date: "22 Mar 2025",
      status: "Completed",
      statusClass: "success",
    },
  ];

  const ratingDistribution = [
    { stars: 5, count: 16 },
    { stars: 4, count: 21 },
    { stars: 3, count: 10 },
    { stars: 2, count: 3 },
    { stars: 1, count: 0 },
  ];

  const maxCount = Math.max(...ratingDistribution.map((r) => r.count));
  const [openModal2, setOpenModal2] = useState(false);
  const handleCloseModal2 = () => {
    setOpenModal2(false);
  };
  const [valueTabs2, setValueTabs2] = React.useState(0);
  const handleChangeTabs2 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs2(newValue);
  };
  return (
    <>
      <div className="main_title">
        <h1>View Vendor</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-vendors")}>
            Manage Vendors
          </button>{" "}
          - View Vendor
        </p>
      </div>
      <div className="cards">
        <div className="gap_p view_page">
          {/* Owner Name */}
          <div className="w_33">
            <h6>Owner Name</h6>
            <p>Arjun Mehta</p>
          </div>

          {/* Email */}
          <div className="w_33">
            <h6>Email</h6>
            <p>arjun.mehta@example.com</p>
          </div>

          {/* Contact Phone */}
          <div className="w_33">
            <h6>Contact Phone</h6>
            <p>+91 98765 43210</p>
          </div>

          {/* Country */}
          <div className="w_33">
            <h6>Country</h6>
            <p>United Arab Emirates</p>
          </div>

          {/* Emirates */}
          <div className="w_33">
            <h6>Emirates</h6>
            <p>Dubai</p>
          </div>

          {/* City */}
          <div className="w_33">
            <h6>City</h6>
            <p>Dubai</p>
          </div>
        </div>
      </div>
      <Box className="custom_tabs1">
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          variant="scrollable"
          className="custom_tabs_links"
        >
          <Tab label="Business Information" {...a11yProps(0)} />
          <Tab label="Personal Details" {...a11yProps(1)} />
          <Tab label="Store Information" {...a11yProps(2)} />
          <Tab label="Earnings" {...a11yProps(3)} />
          <Tab label="Reviews" {...a11yProps(4)} />
          <Tab label="Products" {...a11yProps(5)} />
          <Tab label="Order History" {...a11yProps(6)} />
          <Tab label="Subscription History" {...a11yProps(7)} />
          <Tab label="Vendor Service Bookings" {...a11yProps(8)} />
          <Tab label="Transaction History" {...a11yProps(9)} />
          <Tab label="Referral History" {...a11yProps(10)} />
          <Tab label="Purchased Queries" {...a11yProps(11)} />
          <Tab label="Bouteek Points" {...a11yProps(12)} />
          <Tab label="Campagins" {...a11yProps(13)} />
          <Tab label="Compliance Status" {...a11yProps(14)} />
        </Tabs>
      </Box>
      <div className="cards view_page">
        {/* Personal Details Tab */}
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="wrap_viewDemo_steps">
            <div className="form">
              <div className="gap_p">
                <div className="control_group w_100">
                  <div className="border_box">
                    <label>Email </label>
                    <p>johndoe@yopmail.com</p>
                  </div>
                </div>
                <div className="control_group w_50">
                  <div className="border_box">
                    <label>Uploaded Trade License </label>
                    <div className="doc_preview">
                      <ImageOutlinedIcon /> <p>trade-license.jpg</p>{" "}
                      <IconButton className="btn_rounded primary">
                        <FileDownloadOutlinedIcon />
                      </IconButton>
                    </div>
                  </div>
                </div>
                <div className="control_group w_50">
                  <div className="border_box">
                    <label>Upload Memorandum of Association (MOA) </label>
                    <div className="doc_preview">
                      <ImageOutlinedIcon /> <p>memorandum-of-association.jpg</p>{" "}
                      <IconButton className="btn_rounded primary">
                        <FileDownloadOutlinedIcon />
                      </IconButton>
                    </div>
                  </div>
                </div>
                <div className="control_group w_100">
                  <div className="border_box">
                    <label>Tell us about your business </label>
                    <p>
                      Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                      Animi minima quis labore eveniet dolor deserunt veritatis
                      necessitatibus maiores natus nulla.
                    </p>
                  </div>
                </div>
                <div className="control_group w_100">
                  <div className="border_box">
                    <label>Uploaded Sample Product Images </label>
                    <div
                      className="uploaded_images"
                      style={{ marginTop: "10px" }}
                    >
                      <div className="inner gap_m">
                        <figure>
                          <img
                            src="/static/images/placeholder.png"
                            alt="uploaded Image"
                          />{" "}
                          <IconButton className="btn_rounded">
                            <ClearIcon />
                          </IconButton>
                        </figure>
                        <figure>
                          <img
                            src="/static/images/placeholder.png"
                            alt="uploaded Image"
                          />{" "}
                          <IconButton className="btn_rounded">
                            <ClearIcon />
                          </IconButton>
                        </figure>
                        <figure>
                          <img
                            src="/static/images/placeholder.png"
                            alt="uploaded Image"
                          />{" "}
                          <IconButton className="btn_rounded">
                            <ClearIcon />
                          </IconButton>
                        </figure>
                        <figure>
                          <img
                            src="/static/images/placeholder.png"
                            alt="uploaded Image"
                          />{" "}
                          <IconButton className="btn_rounded">
                            <ClearIcon />
                          </IconButton>
                        </figure>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="control_group w_100">
                  <div className="border_box">
                    <label>Product Video </label>
                    <p>
                      <a href="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4">
                        http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4
                      </a>
                    </p>
                    <div
                      className="uploaded_images"
                      style={{ marginTop: "10px" }}
                    >
                      <div className="inner gap_m">
                        <figure>
                          <img
                            src="/static/images/placeholder.png"
                            alt="uploaded Image"
                          />{" "}
                          <IconButton className="btn_rounded">
                            <ClearIcon />
                          </IconButton>
                        </figure>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="control_group w_100">
                  <div className="border_box">
                    <label>Social Media Links </label>
                    <ul className="social_list">
                      <li>
                        <IconButton className="btn_rounded primary">
                          <img
                            src="/static/images/twitter_icon.svg"
                            alt="Icon"
                          />
                        </IconButton>
                        <p>
                          <a href="https://www.facebook.com/">
                            https://www.facebook.com/
                          </a>
                        </p>
                      </li>
                      <li>
                        <IconButton className="btn_rounded primary">
                          <img
                            src="/static/images/facebook_icon.svg"
                            alt="Icon"
                          />
                        </IconButton>
                        <p>
                          <a href="https://www.twitter.com/">
                            https://twitter.com/
                          </a>
                        </p>
                      </li>
                      <li>
                        <IconButton className="btn_rounded primary">
                          <img
                            src="/static/images/instagram_icon.svg"
                            alt="Icon"
                          />
                        </IconButton>
                        <p>
                          <a href="https://www.instagram.com/">
                            https://www.instagram.com/
                          </a>
                        </p>
                      </li>
                      <li>
                        <img
                          className="tick_tok"
                          src="/static/images/ticktok_icon.svg"
                          alt="Icon"
                        />
                        <p>
                          <a href="https://www.tiktok.com/">
                            https://www.tiktok.com/
                          </a>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="form_btn">
                <Button className="btn btn_primary">Accept</Button>
                <Button className="btn btn_grey" onClick={() => setOpen1(true)}>
                  Reject
                </Button>
              </div>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="gap_p">
            {/* Upload Image */}
            <div className="vew_img no_radius w_100">
              <h6> Image</h6>
              <figure>
                <img src="/static/images/user_placeholder.png" alt="profile" />
              </figure>
            </div>

            {/* Owner Name */}
            <div className="w_33">
              <h6>Owner Name</h6>
              <p>Arjun Mehta</p>
            </div>

            {/* Email */}
            <div className="w_33">
              <h6>Email</h6>
              <p>arjun.mehta@example.com</p>
            </div>

            {/* Contact Phone */}
            <div className="w_33">
              <h6>Contact Phone</h6>
              <p>+91 98765 43210</p>
            </div>

            {/* Date of Birth */}
            <div className="w_33">
              <h6>Date of Birth</h6>
              <p>12 Aug 1994</p>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <div className="table_header">
            <div className="left_s">
              {" "}
              <div className="form">
                <div className="gap_p">
                  <div className="control_group">
                    <label htmlFor="city">Select Store</label>
                    <Select
                      id="city"
                      value={city}
                      onChange={(e: SelectChangeEvent) =>
                        setCity(e.target.value)
                      }
                      fullWidth
                    >
                      <MenuItem disabled value="default">
                        Select Store
                      </MenuItem>
                      <MenuItem value="mumbai">Mumbai</MenuItem>
                      <MenuItem value="pune">Pune</MenuItem>
                      <MenuItem value="ahmedabad">Ahmedabad</MenuItem>
                    </Select>
                  </div>
                </div>
              </div>
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => navigate("store-information")}
              >
                Update Store
              </Button>
            </div>
          </div>

          <Box className="custom_tabs" sx={{ width: "100%", mt: 2 }}>
            <Tabs
              value={valueTabs1}
              onChange={handleChangeTabs1}
              aria-label="view product tabs"
              className="custom_tabs_links tabs_img"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              <Tab label="Store Information" {...a11yProps(0)} />
              <Tab
                icon={<InfoIcon />}
                label="Legal & Documents"
                {...a11yProps(1)}
              />

              <Tab label="Store Policies" {...a11yProps(2)} />
              <Tab label="Shipping & Logistics" {...a11yProps(3)} />
              <Tab label="Delivery & Return Settings" {...a11yProps(4)} />
              <Tab label="Social Media Links" {...a11yProps(5)} />
            </Tabs>
          </Box>

          <CustomTabPanel value={valueTabs1} index={0}>
            <div className="gap_p">
              {/* Upload Logo */}
              <div className="vew_img no_radius w_100">
                <h6> Logo</h6>
                <figure>
                  <img src="/static/images/placeholder.png" alt="profile" />
                </figure>
              </div>

              {/* Short Name */}
              <div className="w_33">
                <h6>Short Name</h6>
                <p>KM Store</p>
              </div>

              {/* Store Name */}
              <div className="w_33">
                <h6>Store Name</h6>
                <p>Kumar Super Mart</p>
              </div>

              {/* Contact Email */}
              <div className="w_33">
                <h6>Contact Email</h6>
                <p>support@kumarsupermart.com</p>
              </div>

              {/* Contact Phone */}
              <div className="w_33">
                <h6>Contact Phone</h6>
                <p>+971 52 345 6789</p>
              </div>

              {/* Country */}
              <div className="w_33">
                <h6>Country</h6>
                <p>United Arab Emirates</p>
              </div>

              {/* Store Address (Emirate) */}
              <div className="w_33">
                <h6>Store Address (Emirate)</h6>
                <p>Dubai</p>
              </div>

              {/* Full Address */}
              <div className="w_33">
                <h6>Address</h6>
                <p>Shop 14, Al Fahidi Street, Bur Dubai, UAE</p>
              </div>

              {/* Category */}
              <div className="w_33">
                <h6>Category</h6>
                <p>Grocery</p>
              </div>

              {/* Sub-category */}
              <div className="w_33">
                <h6>Sub-Category</h6>
                <p>Snacks, Beverages, Bakery, Household</p>
              </div>

              {/* Store Bio */}
              <div className="w_100">
                <h6>Store Bio</h6>
                <p>
                  Kumar Super Mart is a family-owned grocery store offering
                  fresh produce, pantry essentials, beverages, and household
                  items. Serving customers across UAE for over 10 years with a
                  focus on quality, affordability, and fast delivery.
                </p>
              </div>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs1} index={1}>
            <div className="gap_p">
              <div className="title_inner">
                <h3>Trade License Information</h3>
              </div>

              {/* Trade License Document */}
              <div className="w_50">
                <h6>Trade License Document</h6>
                {tradeLicenseImage ? (
                  <div className="upload_image">
                    <div className="upload_image_holder no_radius v2">
                      <figure>
                        <CardMedia component="img" image={tradeLicenseImage} alt="Trade License" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setTradeLicenseImage("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image">
                    <Input
                      sx={{ display: "none" }}
                      type="file"
                      inputProps={{ accept: "image/png,image/jpeg,image/svg+xml" }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = event.target.files;
                        if (files && files[0]) {
                          setTradeLicenseImage(URL.createObjectURL(files[0]));
                        }
                      }}
                    />
                    <span className="upload_image_holder no_radius">
                      <figure className="add_img">
                        <img src="/static/images/placeholder.png" alt="upload" />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="edit" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
                <p>TL_Dubai_2025.pdf</p>
              </div>

              {/* MOA Document */}
              <div className="w_50">
                <h6>Memorandum of Association (MOA)</h6>
                {moaImage ? (
                  <div className="upload_image">
                    <div className="upload_image_holder no_radius v2">
                      <figure>
                        <CardMedia component="img" image={moaImage} alt="MOA Document" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setMoaImage("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image">
                    <Input
                      sx={{ display: "none" }}
                      type="file"
                      inputProps={{ accept: "image/png,image/jpeg,image/svg+xml" }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = event.target.files;
                        if (files && files[0]) {
                          setMoaImage(URL.createObjectURL(files[0]));
                        }
                      }}
                    />
                    <span className="upload_image_holder no_radius">
                      <figure className="add_img">
                        <img src="/static/images/placeholder.png" alt="upload" />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="edit" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
                <p>TL_Dubai_2025.pdf</p>
              </div>

              {/* Verified Status */}
              <div className="w_33">
                <h6>Verification Status</h6>
                <p>Verified by AI</p>
              </div>

              {/* License Expiry */}
              <div className="w_33">
                <h6>License Expiry Date</h6>
                <p>18 Dec 2027</p>
              </div>

              {/* Issuing Authority */}
              <div className="w_33">
                <h6>Issuing Authority</h6>
                <p>Dubai Economy & Tourism (DET)</p>
              </div>

              <div className="w_33">
                <h6>License Status</h6>
                <p>Expired</p>
              </div>
              <div className="btn_flex">
                <Button
                  className="btn btn_primary"
                  onClick={() => setOpen1(true)}
                >
                  Ban Store
                </Button>
              </div>
            </div>
            <div className="cards mt_20">
              <div className="table_header">
                <div className="left_s">
                  <SearchBar
                    searchTerm={searchTerm}
                    setDebouncedSearchTerm={setSearchTerm}
                    placeholder="Search..."
                  />
                </div>
              </div>
              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr. No.</TableCell>
                      <TableCell>Document Name</TableCell>
                      <TableCell>Document Upload Date</TableCell>
                      <TableCell>View Document</TableCell>
                      <TableCell>Document Expiry Date</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {data.map((item, index) => (
                      <TableRow hover key={item.id}>
                        <TableCell>{index + 1}</TableCell>

                        <TableCell>{item.licenseName}</TableCell>

                        <TableCell>{item.uploadedDate}</TableCell>

                        <TableCell>
                          <Button className="btn btn_primary sm">
                            View Document
                          </Button>
                        </TableCell>

                        <TableCell>{item.expiryDate}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs1} index={2}>
            <div className="gap_p">
              {/* Return & Exchange Policy */}
              <div className="w_100">
                <h6>Return & Exchange Policy</h6>
                <p>
                  Customers may return or exchange products within{" "}
                  <strong>7 days</strong> of purchase, provided the item is
                  unused, in original packaging, and accompanied by proof of
                  purchase. Certain items such as personal care products,
                  perishables, and clearance items are non-returnable.
                </p>
              </div>

              {/* Shipping Policy */}
              <div className="w_100">
                <h6>Shipping Policy</h6>
                <p>
                  Orders are processed within <strong>24–48 hours</strong>.
                  Standard delivery takes 2–5 business days depending on the
                  location. Free shipping is available for orders above AED 150.
                  Customers will receive tracking updates via SMS or email.
                </p>
              </div>

              {/* Care Instructions */}
              <div className="w_100">
                <h6>Store Care Instructions</h6>
                <p>
                  Handle all products with care. Keep away from direct sunlight
                  and moisture. For delicate items, follow the cleaning
                  instructions provided on the packaging or product label.
                </p>
              </div>

              {/* Customer Trust Commitment */}
              <div className="w_100">
                <h6>Customer Trust Commitment</h6>
                <p>
                  We are committed to providing high-quality products,
                  transparent policies, and exceptional customer service to
                  ensure complete satisfaction. All concerns are resolved within
                  48 hours.
                </p>
              </div>

              {/* Trust Indicators */}
              <div className="w_33">
                <h6>Authenticity Guaranteed</h6>
                <p>Yes</p>
              </div>

              <div className="w_33">
                <h6>Secure Payments</h6>
                <p>Yes</p>
              </div>

              <div className="w_33">
                <h6>Transparent Returns</h6>
                <p>Yes</p>
              </div>

              <div className="w_33">
                <h6>Privacy Policy</h6>
                <p>Yes</p>
              </div>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs1} index={3}>
            <div className="form">
              {/* SHIPPING METHOD SELECTION */}
              <div
                className="gap_p"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: 8,
                  padding: 16,
                  marginBottom: 24,
                }}
              >
                <div className="title_inner">
                  <h3>Shipping Method Selection</h3>
                </div>

                <div className="w_100">
                  <h6>Bouteek Integrated Shipping</h6>
                  <p>
                    Shipping is handled through Bouteek’s verified courier
                    partners ensuring safe and reliable delivery nationwide.
                  </p>
                </div>

                <div className="w_100">
                  <h6>Manual Courier Coordination</h6>
                  <p>
                    Vendor coordinates delivery independently using their own
                    courier partners.
                  </p>
                </div>
              </div>

              {/* INTEGRATED SHIPPING DETAILS */}
              <div
                className="gap_p"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: 8,
                  padding: 16,
                  marginBottom: 24,
                }}
              >
                <div className="title_inner">
                  <h3>Integrated Shipping</h3>
                </div>

                <div className="w_50">
                  <h6>Primary Pickup Address</h6>
                  <p>Warehouse 14, Al Quoz Industrial Area 3, Dubai, UAE</p>
                </div>

                <div className="w_50">
                  <h6>Contact Phone Number</h6>
                  <p>+971 52 987 1234</p>
                </div>

                <div className="w_100">
                  <h6>Pickup Instructions</h6>
                  <p>
                    Please notify 30 minutes before arrival. Use Gate 2 for
                    easier access to loading bay.
                  </p>
                </div>
              </div>

              {/* NON-RETURNABLE PRODUCTS */}
              <div className="gap_p">
                <div className="title_inner">
                  <h3>Allow Non-Returnable Products</h3>
                </div>

                <div className="w_100">
                  <h6>Allowed For</h6>
                  <p>
                    Hygiene-sensitive items, customized or personalized
                    products.
                  </p>
                </div>
              </div>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs1} index={4}>
            <form className="form">
              <div className="gap_p">
                {/* Delivery & Return Settings */}
                <Box sx={{ border: "1px solid #ddd", borderRadius: 2, p: 2 }}>
                  <div className="form">
                    <div className="gap_p">
                      {/* Delivery SLA (Seller’s Prep Time) */}
                      <div className="title_inner">
                        <h3>Delivery SLA (Seller’s Prep Time)</h3>
                      </div>
                      <p style={{ textAlign: "left" }}>
                        How fast can you prepare an order for pickup?
                      </p>
                      <div className="control_group">
                        <p>Same-day (24h)</p>
                      </div>
                      <div className="control_group">
                        <p>Fast Delivery Enabled</p>
                      </div>
                    </div>
                  </div>
                </Box>

                {/* Return Management */}
              </div>
            </form>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs1} index={5}>
            <div className="gap_p">
              {/* Facebook Link */}
              <div className="w_50">
                <h6>Facebook Link</h6>
                <p>https://www.facebook.com/YourPage</p>
              </div>

              {/* Instagram Link */}
              <div className="w_50">
                <h6>Instagram Link</h6>
                <p>https://www.instagram.com/YourProfile</p>
              </div>

              {/* Twitter Link */}
              <div className="w_50">
                <h6>Twitter Link</h6>
                <p>https://www.twitter.com/YourProfile</p>
              </div>
            </div>
          </CustomTabPanel>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <div className="stats_boxes gap_m">
            {/* TOTAL PAYOUTS */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  AED 0.00
                  <p>Total Payouts</p>
                </h2>
                <figure className="blue">
                  <AttachMoneyOutlinedIcon fontSize="large" />
                </figure>
              </div>
            </a>

            {/* COMPLETED */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  0<p>Completed</p>
                </h2>
                <figure className="sucess">
                  <CheckCircleOutlineIcon fontSize="large" />
                </figure>
              </div>
            </a>

            {/* PENDING */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  0<p>Pending</p>
                </h2>
                <figure className="warning">
                  <AccessTimeOutlinedIcon fontSize="large" />
                </figure>
              </div>
            </a>

            {/* ACTIVE SCHEDULES */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  0<p>Active Schedules</p>
                </h2>
                <figure className="purple">
                  <EventOutlinedIcon fontSize="large" />
                </figure>
              </div>
            </a>
          </div>
          <Box className="custom_tabs mt_20">
            <Tabs
              value={valueTabs2}
              onChange={handleChangeTabs2}
              className="custom_tabs_links"
            >
              <Tab label="Payout History" {...a11yProps(0)} />
              <Tab label="Schedules" {...a11yProps(1)} />
              <Tab label="Balances" {...a11yProps(2)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={valueTabs2} index={0}>
            <div className="cards mt_20">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search vendor or period..."
                    />
                  </Box>
                </div>
                <div className="right_s form">
                  <input type="date" />
                </div>
              </div>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Vendor ID</TableCell>
                      <TableCell>Period</TableCell>
                      <TableCell>Orders</TableCell>
                      <TableCell>Subscription</TableCell>
                      <TableCell>Commission (%)</TableCell>

                      <TableCell>Commission</TableCell>
                      <TableCell>Net Amount</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {payoutData.map((row, index) => (
                      <TableRow key={index} hover>
                        <TableCell>
                          <b>{row.vendorId}</b>
                        </TableCell>

                        <TableCell>{row.period}</TableCell>

                        <TableCell>{row.orders}</TableCell>

                        <TableCell>{row.subscriptionType}</TableCell>

                        <TableCell>{row.commissionRate}</TableCell>

                        <TableCell>{row.commission}</TableCell>

                        <TableCell>
                          <b>{row.netAmount}</b>
                        </TableCell>

                        <TableCell>
                          <span className={`badge1 ${row.statusClass}`}>
                            {row.status}
                          </span>
                        </TableCell>
                        <TableCell>
                          <div className="table_actions v2">
                            <Box>
                              <IconButton
                                onClick={() =>
                                  navigate("/vendor-payouts/view-payout")
                                }
                              >
                                <img
                                  src="/static/images/eye_icon.svg"
                                  alt="View"
                                />
                              </IconButton>
                            </Box>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs2} index={1}>
            <div className="cards form">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search vendors..."
                    />
                  </Box>
                </div>
                <div className="right_s form">
                  <input type="date" />
                </div>
              </div>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr. No</TableCell>
                      <TableCell>Vendor Name</TableCell>
                      <TableCell>Payout Schedule</TableCell>
                      <TableCell>Subscription</TableCell>

                      <TableCell>Commission Rate (%)</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>Expiry Date</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {scheduledPayouts.map((item, index) => (
                      <TableRow key={item.id} hover>
                        {/* Sr No */}
                        <TableCell>{index + 1}</TableCell>

                        {/* Vendor */}
                        <TableCell>
                          <b>{item.vendor}</b>
                        </TableCell>

                        {/* Schedule Type */}
                        <TableCell>
                          <span className="badge1 info">{item.plan}</span>
                        </TableCell>
                        <TableCell>{item.subscriptionType}</TableCell>
                        {/* Commission Rate */}
                        <TableCell>{item.commissionRate}</TableCell>

                        <TableCell>{item.amount}</TableCell>

                        {/* Expiry */}
                        <TableCell>
                          <TextField
                            type="date"
                            defaultValue={item.expiry}
                            fullWidth
                            hiddenLabel
                            size="small"
                          />
                        </TableCell>

                        {/* Actions */}
                        <TableCell>{item.status}</TableCell>
                        <TableCell>
                          <div className="table_actions v2">
                            <Box>
                              <IconButton
                                onClick={() =>
                                  navigate("/vendor-payouts/view-payout")
                                }
                              >
                                <img
                                  src="/static/images/eye_icon.svg"
                                  alt="View"
                                />
                              </IconButton>
                            </Box>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs2} index={2}>
            <div className="cards">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search vendor or vendor ID..."
                    />
                  </Box>
                </div>
                <div className="right_s form">
                  <input type="date" />
                </div>
              </div>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Vendor ID</TableCell>
                      <TableCell>Vendor Name</TableCell>
                      <TableCell>Pending Amount</TableCell>
                      <TableCell>Subscription</TableCell>
                      <TableCell>Commission (%)</TableCell>

                      <TableCell>Last Payout</TableCell>
                      <TableCell>Last Payout Date</TableCell>

                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {vendorBalances.map((item) => (
                      <TableRow key={item.id} hover>
                        {/* Vendor ID */}
                        <TableCell>
                          <b>{item.vendorId}</b>
                        </TableCell>

                        {/* Vendor Name */}
                        <TableCell>
                          <b>{item.vendorName}</b>
                        </TableCell>

                        {/* Pending Amount */}
                        <TableCell>
                          <b className="text_warning">{item.pendingAmount}</b>
                        </TableCell>
                        <TableCell>{item.subscriptionType}</TableCell>

                        <TableCell>{item.commissionRate}</TableCell>

                        {/* Last Payout */}
                        <TableCell>{item.lastPayout}</TableCell>

                        {/* Last Payout Date */}
                        <TableCell>{item.lastPayoutDate}</TableCell>

                        {/* Status */}

                        <TableCell>
                          <div className="table_actions v2">
                            <Box>
                              <IconButton
                                onClick={() =>
                                  navigate("/vendor-payouts/view-payout")
                                }
                              >
                                <img
                                  src="/static/images/eye_icon.svg"
                                  alt="View"
                                />
                              </IconButton>
                            </Box>
                            <Box>
                              <IconButton onClick={() => setOpenModal2(true)}>
                                <PaymentIcon />
                              </IconButton>
                            </Box>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </CustomTabPanel>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={4}>
          <div className="stats_boxes gap_m">
            {/* TOTAL REVIEWS */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  50
                  <p>Total Reviews</p>
                </h2>
                <figure className="warning">
                  <StarIcon fontSize="large" />
                </figure>
              </div>
            </a>

            {/* AVERAGE RATING */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  4.0
                  <p>Average Rating</p>
                </h2>
                <figure className="sucess">
                  <TrendingUpIcon fontSize="large" />
                </figure>
              </div>
            </a>

            {/* VERIFIED PURCHASES */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  32
                  <p>Verified Purchases</p>
                </h2>
                <figure className="blue">
                  <VerifiedIcon fontSize="large" />
                </figure>
              </div>
            </a>

            {/* PENDING REVIEWS */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  4<p>Pending Review</p>
                </h2>
                <figure className="danger">
                  <ErrorOutlineIcon fontSize="large" />
                </figure>
              </div>
            </a>
          </div>
          <div className="cards rating_distribution mt_20">
            <h4 className="card_title">Rating Distribution</h4>

            <div className="rating_dist_list">
              {ratingDistribution.map((item) => (
                <div className="rating_row" key={item.stars}>
                  {/* Stars */}
                  <div className="stars">
                    {item.stars} <span>★</span>
                  </div>

                  {/* Progress bar */}
                  <div className="bar">
                    <span
                      className="fill"
                      style={{
                        width: `${(item.count / maxCount) * 100}%`,
                      }}
                    />
                  </div>

                  {/* Count */}
                  <div className="count">{item.count}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="reviews_wrapper mt_20">
            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    searchTerm={searchTerm}
                    setDebouncedSearchTerm={setSearchTerm}
                    placeholder="Search product..."
                  />
                </Box>
                <div className="form">
                  <select>
                    <option value="all">All Ratings</option>
                    <option value="footwear">5 Star</option>
                    <option value="clothing">4 Star</option>
                    <option value="accessories">3 Star</option>
                    <option value="accessories">2 Star</option>
                    <option value="accessories">1 Star</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="reviews_list">
              {reviews.map((row) => (
                <div
                  className="review_card"
                  key={row.id}
                  onClick={() => navigate("/manage-products/view")}
                >
                  {/* LEFT – User */}
                  <div className="review_user">
                    <figure className="avatar">{row.name.charAt(0)}</figure>

                    <div className="user_info">
                      <h4>
                        {row.name}
                        {row.verified && (
                          <span className="verified_badge">✔ Verified</span>
                        )}
                      </h4>
                      <p>{row.email}</p>
                      <small>{row.date}</small>
                    </div>
                  </div>

                  {/* CENTER – Review + Product */}
                  <div className="review_content">
                    {/* Product Info */}
                    <div className="product_info">
                      <span className="pid">#{row.productId}</span>
                      <span className="pname">{row.productName}</span>
                    </div>

                    {/* Rating */}
                    <div className="rating">
                      {"⭐".repeat(row.rating)}
                      {row.rating < 5 && "☆".repeat(5 - row.rating)}
                    </div>

                    <h5>{row.title}</h5>
                    <p>{row.review}</p>
                  </div>
                  <div className="action">
                    <IconButton>
                      <img src="/static/images/trash2_icon.svg" alt="icon" />
                    </IconButton>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={5}>
          <div className="stats_boxes gap_m">
            <a className="cards">
              <div className="data_top">
                <h2>
                  15
                  <p>Total Products</p>
                </h2>
                <figure className="blue">
                  <Inventory2OutlinedIcon fontSize="large" />
                </figure>
              </div>
            </a>

            <a className="cards">
              <div className="data_top">
                <h2>
                  15
                  <p>Active</p>
                </h2>
                <figure className="blue">
                  <CheckCircleIcon fontSize="large" />
                </figure>
              </div>
            </a>

            <a className="cards">
              <div className="data_top">
                <h2>
                  0<p>Low Stock</p>
                </h2>
                <figure className="warning">
                  <ReportProblemOutlinedIcon fontSize="large" />
                </figure>
              </div>
            </a>

            <a className="cards">
              <div className="data_top">
                <h2>
                  AED 1,807,668
                  <p>Inventory Value</p>
                </h2>
                <figure className="warning">
                  <AccountBalanceWalletOutlinedIcon fontSize="large" />
                </figure>
              </div>
            </a>
          </div>
          <div className="table_flex mt_20">
            <div className="lt">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search products..."
                    />
                  </Box>
                  <div className="form">
                    <select>
                      <option value="all">Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                    <select>
                      <option value="all">Category</option>
                      <option value="footwear">Footwear</option>
                      <option value="clothing">Clothing</option>
                      <option value="accessories">Accessories</option>
                    </select>
                    <select>
                      <option value="all">Stock Status</option>
                      <option value="instock">In Stock</option>
                      <option value="lowstock">Low Stock</option>
                      <option value="outofstock">Out of Stock</option>
                    </select>
                  </div>
                </div>
              </div>
              <TableContainer className="table_container" sx={{ mt: 3 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Vendor Details</TableCell>
                      <TableCell>Business Details</TableCell>
                      <TableCell>Product Detail</TableCell>
                      <TableCell>Category</TableCell>
                      <TableCell>Brand</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Make Trending</TableCell>
                      <TableCell>Review</TableCell>
                      <TableCell>Stock</TableCell>

                      <TableCell>Created Date</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredProducts.map((item, index) => (
                      <TableRow key={index} hover>
                        <TableCell>{item.id}</TableCell>
                        <TableCell>
                          <Box
                            component="a"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate("/manage-users/detail", {
                                state: { user: item.vendor },
                              });
                            }}
                            className="user_block click_action"
                          >
                            <p>
                              <b>{item.vendor.name}</b>
                              <span>
                                {item.vendor.email}{" "}
                                <img
                                  src="/static/images/tick_icon.svg"
                                  alt="verified"
                                />
                              </span>
                              <span>{item.vendor.phone}</span>
                            </p>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box display="flex" alignItems="center" gap={2}>
                            <img
                              src={item.image}
                              alt={item.name}
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "6px",
                                objectFit: "cover",
                                background: "#f5f5f5",
                              }}
                            />
                            <span>{item.name}</span>
                          </Box>
                        </TableCell>
                        <TableCell>{item.category}</TableCell>
                        <TableCell>{item.brand}</TableCell>
                        <TableCell>
                          <SwitchToggle />
                        </TableCell>
                        <TableCell>
                          <SwitchToggle />
                        </TableCell>
                        <TableCell>
                          <span
                            className={`stock_value ${item.stock <= 10 ? "low" : "normal"
                              }`}
                          >
                            {item.stock}
                          </span>
                        </TableCell>

                        <TableCell>{item.createdDate}</TableCell>
                        <TableCell>
                          <Box display="flex" gap={1}>
                            <IconButton
                              onClick={() => navigate("/manage-products/view")}
                            >
                              <img
                                src="/static/images/eye_icon.svg"
                                alt="View"
                              />
                            </IconButton>
                            <IconButton
                              onClick={() => navigate("/add-product")}
                            >
                              <img
                                src="/static/images/edit2_icon.svg"
                                alt="Edit"
                              />
                            </IconButton>
                            <IconButton>
                              <img
                                src="/static/images/trash2_icon.svg"
                                alt="Delete"
                              />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div className="rt">
              <div className="ai_panel">
                <h4>AI Insights</h4>

                <div className="ai_alert warning">
                  <span className="icon">⚠️</span>
                  <p>
                    <b>7 SKUs</b> need immediate attention
                  </p>
                </div>

                <div className="ai_alert danger">
                  <span className="icon">⛔</span>
                  <p>
                    <b>3 SKUs</b> have zero sales in 30 days
                  </p>
                </div>

                <small className="ai_update">
                  Next updated ETA: <b>May 5, 2024</b>
                </small>

                <div className="ai_sku_list">
                  <div className="ai_sku_row">
                    <div className="ai_sku_info">
                      <h5>#PRD_002</h5>
                      <p>Likely to go out of stock by May</p>
                    </div>
                    <button className="ai_action_btn">Actions ▾</button>
                  </div>

                  <div className="ai_sku_row">
                    <div className="ai_sku_info">
                      <h5>#PRD_010</h5>
                      <p>Likely to go out of stock by May</p>
                    </div>
                    <button className="ai_action_btn">Actions ▾</button>
                  </div>
                </div>

                {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
              </div>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={6}>
          <div className="stats_boxes gap_m">
            {/* Total Orders */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  120
                  <p>Total Orders</p>
                </h2>
                <figure className="blue">
                  <Inventory2OutlinedIcon fontSize="large" />
                </figure>
              </div>

              <div className="ai_insight positive">
                <span>12.5% increase</span>
              </div>
            </a>

            {/* Total Revenue */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  AED 250,000
                  <p>Total Revenue</p>
                </h2>
                <figure className="green">
                  <AttachMoneyOutlinedIcon fontSize="large" />
                </figure>
              </div>

              <div className="ai_insight positive">
                <span>8.3% growth this month</span>
              </div>
            </a>

            {/* Pending Orders */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  12
                  <p>Pending</p>
                </h2>
                <figure className="warning">
                  <HourglassEmptyOutlinedIcon fontSize="large" />
                </figure>
              </div>

              <div className="ai_insight negative">
                <span>5% higher than last week</span>
              </div>
            </a>

            {/* Processing Orders */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  34
                  <p>Processing</p>
                </h2>
                <figure className="blue">
                  <AutorenewOutlinedIcon fontSize="large" />
                </figure>
              </div>

              <div className="ai_insight neutral">
                <span>Stable processing rate</span>
              </div>
            </a>
          </div>

          <div className="table_flex mt_20">
            <div className="lt">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search orders..."
                    />
                  </Box>
                  <div className="form">
                    <div className="control_group">
                      <input type="date" />
                    </div>
                    <select>
                      <option value="all">Status</option>
                      <option value="pending">Pending</option>
                      <option value="confirmed">Confirmed</option>
                      <option value="shipped">Shipped</option>
                      <option value="delivered">Delivered</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                    <select>
                      <option value="all">Payment</option>
                      <option value="card">Card</option>
                      <option value="cash">Cash</option>
                    </select>
                    <select>
                      <option value="all">Category</option>
                      <option value="electronics">Electronics</option>
                      <option value="fashion">Fashion</option>
                    </select>
                  </div>
                </div>
                <div className="right_s"></div>
              </div>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Order</TableCell>
                      <TableCell>Vendor Details</TableCell>
                      <TableCell>Customer Details</TableCell>
                      <TableCell>Category</TableCell>
                      <TableCell>Date / Time</TableCell>
                      <TableCell>Total</TableCell>
                      <TableCell>Payment</TableCell>
                      <TableCell>Payment Method</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {orderData.map((order, index) => (
                      <TableRow key={index} hover>
                        {/* Order */}
                        <TableCell>
                          <div className="user_block">
                            <p>
                              {" "}
                              <b>{order.orderId}</b>
                              {order.store}
                            </p>
                          </div>
                        </TableCell>
                        {/* Vendor */}
                        <TableCell>
                          <div className="user_block">
                            <p>
                              <b>{order.vendor.name}</b>
                              {order.vendor.email}
                            </p>
                          </div>
                        </TableCell>

                        {/* Customer */}
                        <TableCell>
                          <div className="user_block">
                            <p>
                              {" "}
                              <b>{order.customer.name}</b>
                              {order.customer.email}
                            </p>
                          </div>
                        </TableCell>

                        {/* Date */}
                        <TableCell>
                          <p>{order.date}</p>
                          <span className="sub_text">{order.time}</span>
                        </TableCell>

                        {/* Total */}
                        <TableCell>
                          <p className="fw_600">{order.total}</p>
                        </TableCell>

                        {/* Payment */}
                        <TableCell>
                          <span className="badge1 success">paid</span>
                        </TableCell>
                        <TableCell>
                          <span className="sub_text fw_600">
                            {order.paymentMethod}
                          </span>
                        </TableCell>

                        {/* Status */}
                        <TableCell>
                          <span
                            className={`badge1 ${order.status.toLowerCase()}`}
                          >
                            {order.status}
                          </span>
                        </TableCell>

                        {/* Actions */}
                        <TableCell>
                          <IconButton
                            onClick={() => navigate("/order-management/view")}
                          >
                            <img src="/static/images/eye_icon.svg" alt="View" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div className="rt">
              <div className="ai_panel">
                <h4>AI Insights</h4>

                <div className="ai_alert warning">
                  <span className="icon">⚠️</span>
                  <p>
                    <b>7 SKUs</b> need immediate attention
                  </p>
                </div>

                <div className="ai_alert danger">
                  <span className="icon">⛔</span>
                  <p>
                    <b>3 SKUs</b> have zero sales in 30 days
                  </p>
                </div>

                <small className="ai_update">
                  Next updated ETA: <b>May 5, 2024</b>
                </small>

                <div className="ai_sku_list">
                  <div className="ai_sku_row">
                    <div className="ai_sku_info">
                      <h5>#PRD_002</h5>
                      <p>Likely to go out of stock by May</p>
                    </div>
                    <button className="ai_action_btn">Actions ▾</button>
                  </div>

                  <div className="ai_sku_row">
                    <div className="ai_sku_info">
                      <h5>#PRD_010</h5>
                      <p>Likely to go out of stock by May</p>
                    </div>
                    <button className="ai_action_btn">Actions ▾</button>
                  </div>
                </div>

                {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
              </div>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={7}>
          <div className="stats_boxes gap_m">
            {/* TOTAL SUBSCRIPTIONS */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  28
                  <p>Total Subscriptions Bought</p>
                </h2>
                <figure className="blue">
                  <SubscriptionsIcon fontSize="large" />
                </figure>
              </div>
            </a>

            {/* SUBSCRIPTION AMOUNT */}
            <a className="cards">
              <div className="data_top">
                <h2>
                  AED 245,800
                  <p>Subscription Amount</p>
                </h2>
                <figure className="warning">
                  <AccountBalanceWalletOutlinedIcon fontSize="large" />
                </figure>
              </div>
            </a>
          </div>
          <div className="table_flex mt_20">

            <div className="lt">
              <div className="table_header mt_20">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search subscription..."
                    />
                  </Box>
                  <div className="form">
                    <select>
                      <option>All Plans</option>
                      <option>Basic</option>
                      <option>Pro</option>
                      <option>Scale+</option>
                    </select>
                  </div>
                  <div className="form">
                    <select>
                      <option>Feature Usage</option>
                      <option>Low Usage</option>
                      <option>Medium Usage</option>
                      <option>High Usage</option>
                    </select>
                  </div>
                  <div className="form">
                    <select>
                      <option>Revenue Contribution</option>
                      <option>Top 20%</option>
                      <option>Mid Tier</option>
                      <option>Low Tier</option>
                    </select>
                  </div>
                  <div className="form">
                    <select>
                      <option>Vendor Status</option>
                      <option>Active</option>
                      <option>At Risk</option>
                      <option>Churned</option>
                    </select>
                  </div>
                  <div className="form">
                    <select>
                      <option>AI Cost Impact</option>
                      <option>Low</option>
                      <option>Medium</option>
                      <option>High</option>
                    </select>
                  </div>
                </div>
                <div className="right_s" />
              </div>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr. No.</TableCell>
                      <TableCell>Subscription Name</TableCell>
                      <TableCell>Validity</TableCell>
                      <TableCell>Price</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>End Date</TableCell>
                      <TableCell>Change Subscription</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {subscriptionHistory
                      .filter((sub) =>
                        sub.name.toLowerCase().includes(searchTerm.toLowerCase()),
                      )
                      .map((sub, index) => (
                        <TableRow key={sub.id} hover>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>
                            <strong>{sub.name}</strong>
                          </TableCell>

                          <TableCell>{sub.validity}</TableCell>
                          <TableCell>
                            <strong>{sub.price}</strong>
                          </TableCell>
                          <TableCell>{sub.startDate}</TableCell>
                          <TableCell>{sub.endDate}</TableCell>
                          <TableCell className="form">
                            <select>
                              <option value="all">Change</option>
                              <option value="footwear">Basic</option>
                              <option value="clothing">Premium</option>
                              <option value="accessories">Freemium</option>
                            </select>
                          </TableCell>
                          <TableCell>
                            <IconButton
                              onClick={() => navigate("view-subscription")}
                            >
                              <img src="/static/images/eye_icon.svg" alt="View" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>

            </div>
            <div className="rt">
              <div className="ai_panel">
                <h4>AI Insights</h4>

                {/* Insight 1 */}
                <div className="ai_alert info">
                  <span className="icon">ℹ️</span>
                  <p>
                    Vendor paying for <b>Pro</b> but using only <b>20%</b> of features.
                  </p>
                </div>

                {/* Insight 2 */}
                <div className="ai_alert warning">
                  <span className="icon">⚠️</span>
                  <p>
                    Vendor consistently hitting <b>AI limits</b> — upgrade recommended.
                  </p>
                </div>

                {/* Insight 3 */}
                <div className="ai_alert danger">
                  <span className="icon">⛔</span>
                  <p>
                    High-revenue vendor at <b>risk of churn</b> due to plan limits.
                  </p>
                </div>

                {/* Insight 4 */}
                <div className="ai_alert success">
                  <span className="icon">✅</span>
                  <p>
                    Segment X generates <b>60% revenue</b> but only <b>40%</b> are on Scale+.
                  </p>
                </div>

                {/* Update info */}
                <small className="ai_update">
                  Next updated ETA: <b>May 5, 2024</b>
                </small>

                {/* Governance Section styled like SKU list */}
                <div className="ai_sku_list">
                  <div className="ai_sku_row">
                    <div className="ai_sku_info">
                      <h5>Admin Approval</h5>
                      <p>Plan changes require admin confirmation</p>
                    </div>
                  </div>

                  <div className="ai_sku_row">
                    <div className="ai_sku_info">
                      <h5>Audit Logs</h5>
                      <p>Who, When, From → To, and Reason tracked</p>
                    </div>
                  </div>

                  <div className="ai_sku_row">
                    <div className="ai_sku_info">
                      <h5>Safety Checks</h5>
                      <p>Warn if active orders or AI processes running</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={8}>
          {/* Summary Stats */}
          <div className="stats_boxes gap_m">
            <div className="cards">
              <div className="data_top">
                <h2>
                  120 <p>Total Bookings</p>
                </h2>
                <figure className="blue">
                  <Inventory2OutlinedIcon fontSize="large" />
                </figure>
              </div>
              <div className="ai_insight positive">
                <span>12.5% increase</span>
              </div>
            </div>
            <div className="cards">
              <div className="data_top">
                <h2>
                  AED 250,000 <p>Total Revenue</p>
                </h2>
                <figure className="green">
                  <AttachMoneyOutlinedIcon fontSize="large" />
                </figure>
              </div>
              <div className="ai_insight positive">
                <span>8.3% growth this month</span>
              </div>
            </div>
            <div className="cards">
              <div className="data_top">
                <h2>
                  14 <p>Pending</p>
                </h2>
                <figure className="warning">
                  <HourglassEmptyOutlinedIcon fontSize="large" />
                </figure>
              </div>
              <div className="ai_insight negative">
                <span>7% higher than last week</span>
              </div>
            </div>
            <div className="cards">
              <div className="data_top">
                <h2>
                  32 <p>Ongoing</p>
                </h2>
                <figure className="blue">
                  <AutorenewOutlinedIcon fontSize="large" />
                </figure>
              </div>
              <div className="ai_insight neutral">
                <span>Stable Ongoing rate</span>
              </div>
            </div>
          </div>

     

          <div className="table_flex mt_20">
            <div className="lt">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search orders..."
                    />
                  </Box>
                  <div className="form">
                    <div className="control_group">
                      <input type="date" />
                    </div>
                    <select>
                      <option value="all">Status</option>
                      <option value="pending">Pending</option>
                      <option value="accepted">Accepted</option>
                      <option value="ongoing">Ongoing</option>
                    </select>
                
                  </div>
                </div>
              
              </div>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Booking ID</TableCell>
                      <TableCell>Service Provider Details</TableCell>
                      <TableCell>Vendor Details</TableCell>
                      <TableCell>Booking Date / Time</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>Payment</TableCell>
                      <TableCell>AI Risk Score</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ongoingOrders.map((order) => (
                      <TableRow key={order.id} hover>
                        <TableCell>
                          <b>BK-2025-00{order.id}</b>
                        </TableCell>
                        <TableCell>
                          <Box className="user_block">
                            <p>
                              <b>{order.providerName}</b>
                              <span>support@serviceprovider.com</span>
                            </p>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className="user_block">
                            <p>
                              <b>TechHub Electronics</b>
                              <span>sales@techhub.com</span>
                            </p>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">{order.date}</Typography>
                          <Typography variant="caption" color="textSecondary">
                            {order.time}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <b>AED {order.price}.00</b>
                        </TableCell>
                        <TableCell>
                          <span
                            className={`badge1 ${order.paymentStatus === "Paid" ? "success" : "warning"}`}
                          >
                            {order.paymentStatus}
                          </span>
                        </TableCell>
                        <TableCell>
                          <span className="badge1 danger">High Risk</span>
                        </TableCell>
                        <TableCell>
                          <IconButton onClick={() => navigate("view-service")}>
                            <img src="/static/images/eye_icon.svg" alt="View" />
                          </IconButton>
                          <IconButton
                            onClick={(e) => handleActionClick(e, order)}
                          >
                            <MoreVertIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

         
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={9}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search transaction..."
                />
              </Box>
            </div>
            <div className="right_s form">
              {" "}
              <select>
                <option value="all">Status</option>
                <option value="high">Pending</option>
                <option value="medium">Completed</option>
                <option value="low">Failed</option>
              </select>
            </div>
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Transaction ID</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Gateway</TableCell>
                  <TableCell>Reference</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {transactionLogs.map((item) => (
                  <TableRow key={item.id} hover>
                    {/* Transaction ID */}
                    <TableCell>
                      <b>{item.id}</b>
                    </TableCell>

                    {/* Type */}
                    <TableCell>{item.type}</TableCell>

                    {/* Amount */}
                    <TableCell>
                      <b>{item.amount}</b>
                    </TableCell>

                    {/* Gateway */}
                    <TableCell>{item.gateway}</TableCell>

                    {/* Reference */}
                    <TableCell>{item.reference}</TableCell>

                    {/* Date */}
                    <TableCell>{item.date}</TableCell>

                    {/* Status */}
                    <TableCell>
                      <span className={`badge1 ${item.statusClass}`}>
                        {item.status}
                      </span>
                    </TableCell>
                    <TableCell>
                      <Box>
                        <IconButton
                          onClick={() => navigate("/financial-reports/view")}
                        >
                          <img src="/static/images/eye_icon.svg" alt="icon" />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={10}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search referral..."
                />
              </Box>
            </div>
            <div className="right_s" />
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Phone Number</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {referralHistory
                  .filter(
                    (ref) =>
                      ref.name
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                      ref.email
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()),
                  )
                  .map((ref, index) => (
                    <TableRow key={index} hover>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>
                        <strong>{ref.name}</strong>
                      </TableCell>
                      <TableCell>{ref.email}</TableCell>
                      <TableCell>{ref.phone}</TableCell>
                      <TableCell>
                        <span
                          style={{
                            color:
                              ref.status === "Completed"
                                ? "#4caf50"
                                : "#ff9800",
                            fontWeight: 500,
                          }}
                        >
                          {ref.status}
                        </span>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={11}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search purchases..."
                />
              </Box>
            </div>
            <div className="right_s" />
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>No. of Queries</TableCell>
                  <TableCell>Amount Paid</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {purchasedQueries
                  .filter(
                    (item) =>
                      item.queries.toString().includes(searchTerm) ||
                      item.amount
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()),
                  )
                  .map((item, index) => (
                    <TableRow key={index} hover>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>
                        <strong>{item.queries}</strong>
                      </TableCell>
                      <TableCell>
                        <strong style={{ color: "#4caf50" }}>
                          {item.amount}
                        </strong>
                      </TableCell>
                      <TableCell>{item.date}</TableCell>
                      <TableCell>
                        <IconButton
                          onClick={() => navigate("view-subscription")}
                        >
                          <img src="/static/images/eye_icon.svg" alt="View" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={12}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search points..."
                />
              </Box>
            </div>
            <div className="right_s" />
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Points Type</TableCell>
                  <TableCell>Reference ID</TableCell>
                  <TableCell>No. of Points</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {boutiquePoints
                  .filter(
                    (item) =>
                      item.type
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                      item.referenceId
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()),
                  )
                  .map((item, index) => (
                    <TableRow key={index} hover>
                      <TableCell>{index + 1}</TableCell>

                      <TableCell>
                        <strong>{item.type}</strong>
                      </TableCell>

                      <TableCell>{item.referenceId}</TableCell>

                      <TableCell>
                        <strong
                          style={{
                            color: "#1976d2",
                            fontWeight: 600,
                          }}
                        >
                          +{item.points}
                        </strong>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={13}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search campaigns..."
                />
              </Box>
            </div>
            <div className="right_s" />
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Campaign Name</TableCell>
                  <TableCell>Campaign Type</TableCell>
                  <TableCell>Discount Type</TableCell>
                  <TableCell>Discount Value</TableCell>
                  <TableCell>Start Date</TableCell>
                  <TableCell>End Date</TableCell>
                  <TableCell>Min Purchase</TableCell>
                  <TableCell>Usage Limit</TableCell>
                  <TableCell>Created Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {campaigns
                  .filter(
                    (item) =>
                      item.campaignName
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                      item.campaignType
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()),
                  )
                  .map((item, index) => (
                    <TableRow key={index} hover>
                      <TableCell>{index + 1}</TableCell>

                      <TableCell>
                        <strong>{item.campaignName}</strong>
                      </TableCell>

                      <TableCell>{item.campaignType}</TableCell>

                      <TableCell>{item.discountType || "-"}</TableCell>

                      <TableCell>
                        {item.discountValue ? `${item.discountValue}%` : "-"}
                      </TableCell>

                      <TableCell>{item.startDate}</TableCell>
                      <TableCell>{item.endDate}</TableCell>

                      <TableCell>
                        {item.minPurchase ? `₹${item.minPurchase}` : "-"}
                      </TableCell>

                      <TableCell>{item.usageLimit || "Unlimited"}</TableCell>

                      <TableCell>{item.createdDate}</TableCell>
                      <TableCell>
                        <div className="table_actions v2">
                          <Box>
                            <IconButton
                              onClick={() => navigate("view-campaign")}
                            >
                              <img
                                src="/static/images/eye_icon.svg"
                                alt="View"
                              />
                            </IconButton>
                          </Box>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={14}>
          <div className="compliance">
            {/* Overall Compliance Score */}
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Overall Compliance Score:
            </Typography>
            <Typography>"Your Compliance Status: GOOD"</Typography>

            <Box mt={2}>
              <Typography display="inline" mr={1}>
                Colour:
              </Typography>
              <CircleIcon
                sx={{ color: "green", fontSize: 20, verticalAlign: "middle" }}
              />
            </Box>

            <Box mt={1}>
              <Typography>Or:</Typography>
              <Stack direction="row" spacing={1} mt={1} mb={2}>
                <Stack direction="row" spacing={0.5} alignItems="center">
                  <CircleIcon sx={{ color: "#FFB300", fontSize: 18 }} />
                  <Typography>Attention Needed</Typography>
                </Stack>
                <Stack direction="row" spacing={0.5} alignItems="center">
                  <CircleIcon sx={{ color: "#D32F2F", fontSize: 18 }} />
                  <Typography>At Risk</Typography>
                </Stack>
              </Stack>
            </Box>

            <Divider sx={{ mb: 2 }} />

            {/* Business Verification Status */}
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Business Verification Status:
            </Typography>

            <Stack spacing={1} mb={2}>
              <Box display="flex" alignItems="center">
                <Typography>Business License:</Typography>
                <CheckIcon color="success" fontSize="small" />
                <Typography>Verified</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography>Expiry Reminder:</Typography>
                <Typography>License expires in 40 days</Typography>
              </Box>
            </Stack>

            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Vendor Agreement & Policy Compliance
            </Typography>

            <Stack spacing={1} mb={2}>
              <Box display="flex" gap={2}>
                <Typography>Terms & Conditions:</Typography>
                <CheckIcon color="success" fontSize="small" />
                <Typography>Accepted</Typography>
              </Box>
              <Box display="flex" gap={2}>
                <Typography>Privacy Policy:</Typography>
                <CheckIcon color="success" fontSize="small" />
                <Typography>Accepted</Typography>
              </Box>
              <Box display="flex" gap={2}>
                <Typography>Commission Policy:</Typography>
                <CheckIcon color="success" fontSize="small" />
                <Typography>Accepted</Typography>
              </Box>
              <Box display="flex" gap={2}>
                <Typography>Last Update:</Typography>
                <Typography>12 Jan 2025</Typography>
              </Box>
            </Stack>

            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Product Compliance Health
            </Typography>

            <Stack spacing={1} mb={2}>
              <Typography>Live Products: 42</Typography>
              <Typography>Compliance Issues: 3</Typography>
              <Typography>
                Rejected Products: 1 (Violates image guidelines)
              </Typography>
              <Typography>Pending Review: 2</Typography>
            </Stack>

            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Customer Service Compliance
            </Typography>

            <Stack spacing={1}>
              <Typography>Order Cancellation Rate: 2% (Good)</Typography>
              <Typography>Late Shipment Rate: 4% (Acceptable)</Typography>
              <Typography>
                Unanswered Customer Chats: 1 (Respond Required)
              </Typography>
              <Typography>Policy Violations: 0</Typography>
            </Stack>
          </div>
        </CustomTabPanel>
      </div>
      <RejectReasonModal
        open={open1}
        onClose={handleCloseModal1}
        setOpen={setOpen1}
      />
      <SendPayout
        open={openModal2}
        onClose={handleCloseModal2}
        setOpen={setOpenModal2}
      />
      <ViewHealthScores
        open={open3}
        onClose={handleCloseModal3}
        setOpen={setOpen3}
      />

      {/* Action Menu for Bookings */}
      <Menu
        anchorEl={anchorEl}
        open={openActionMenu}
        onClose={handleActionClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleActionClose}>Change Status</MenuItem>
        <MenuItem onClick={handleActionClose}>Ban Service Provider</MenuItem>
        <MenuItem onClick={handleActionClose}>Initiate Payout</MenuItem>
        <MenuItem onClick={handleActionClose}>Contact Vendor</MenuItem>
      </Menu>
    </>
  );
};

export default ViewVendor;
